import React from "react";
import { Link } from "react-router-dom";
import { MapPin, DollarSign, ArrowRight, Briefcase } from "lucide-react";

const JobCard = ({ job }) => {
  return (
    <div className="glass-card rounded-2xl p-6 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 group border border-slate-100/50">
      <div className="flex items-start justify-between mb-4">
        <div className="bg-blue-50 p-3 rounded-xl group-hover:bg-blue-600 transition-colors duration-300">
          <Briefcase className="w-6 h-6 text-blue-600 group-hover:text-white" />
        </div>
        <span className="bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full">
          Full Time
        </span>
      </div>

      <h2 className="text-xl font-bold text-slate-900 mb-1 group-hover:text-blue-600 transition-colors">
        {job.title}
      </h2>
      <p className="text-slate-500 font-medium text-sm mb-4">{job.company}</p>

      <div className="flex flex-col gap-2 mb-6">
        <div className="flex items-center gap-2 text-slate-600 text-sm">
          <MapPin size={16} className="text-slate-400" />
          <span>Remote / Hybrid</span>
        </div>
        <div className="flex items-center gap-2 text-slate-600 text-sm">
          <DollarSign size={16} className="text-slate-400" />
          <span>$80k - $120k</span>
        </div>
      </div>

      <Link
        to={`/job/${job.id}`}
        className="flex items-center justify-center gap-2 w-full py-3 bg-slate-900 text-white rounded-xl font-semibold transition-all hover:bg-slate-800 active:scale-95 group/btn"
      >
        View Details
        <ArrowRight size={18} className="group-hover/btn:translate-x-1 transition-transform" />
      </Link>
    </div>
  );
};

export default JobCard;

